import { useState } from "react";
import axios, { API } from "../api";

/** Soft banner shown when the user hasn't verified their email yet. */
export function EmailVerifyBanner({ email }) {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const resend = async () => {
    setSending(true);
    setError("");
    try {
      const res = await axios.post(`${API}/auth/resend-verification`);
      if (res.data.status === "sent") setSent(true);
      else if (res.data.status === "already_verified") setDismissed(true);
      else setError("Could not resend right now");
    } catch (e) {
      setError(e?.response?.data?.detail || "Could not resend");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="verify-banner" data-testid="verify-banner">
      <span className="verify-banner-text">
        {sent ? `✓ Sent! Check ${email}` : `✉️ Verify your email — we sent a link to ${email}`}
      </span>
      <div className="verify-banner-actions">
        {!sent && (
          <button
            className="verify-banner-btn"
            onClick={resend}
            disabled={sending}
            data-testid="verify-resend-btn"
          >
            {sending ? "..." : "Resend"}
          </button>
        )}
        <button
          className="verify-banner-close"
          onClick={() => setDismissed(true)}
          data-testid="verify-banner-close"
          aria-label="Dismiss"
        >×</button>
      </div>
      {error && <span className="verify-banner-error">{error}</span>}
    </div>
  );
}
